/* DACKO workshop courses: from 990px, pushes each part of a card (title, price, note, button and
   each group) down so it starts at the same height in both cards, whatever the copy length
   (Casey 2026-09-27). CSS subgrid would align the rows, but the image through the button is one
   sticky box, and a grid item only sticks inside its own row. Re-inits on shopify:section:load
   for the Theme Editor. */
(() => {
  // Head and every group, in card order. Both courses carry the same groups (overview, duration,
  // skill level, what you will learn, tools), so each starts level across the cards (Casey
  // 2026-09-27). Head-only alignment was tried the same day while the cards had different groups.
  const GROUPS = ['title', 'price', 'price-note', 'cta', 'copy--overview', 'copy--learn', 'copy--tools', 'copy--extra', 'copy--extra-2'];
  const desktop = window.matchMedia('(min-width: 990px)');

  function align(root) {
    // Sticky and transitions off while measuring: a stuck head would shift the tops being
    // compared, and a transitioning margin reads as its old value
    root.classList.add('is-measuring');
    root.querySelectorAll('[data-courses-offset]').forEach((el) => {
      el.style.marginTop = '';
      delete el.dataset.coursesOffset;
    });

    const cards = Array.from(root.querySelectorAll('.dacko-workshop-courses__card'));
    if (!desktop.matches || cards.length < 2) {
      root.classList.remove('is-measuring');
      return;
    }

    GROUPS.forEach((group) => {
      const els = cards.map((card) => card.querySelector(`.dacko-workshop-courses__${group}`)).filter(Boolean);
      if (els.length < 2) return;
      const lowest = Math.max(...els.map((el) => el.getBoundingClientRect().top));
      els.forEach((el) => {
        // Re-read after each push: a margin collapsing with the one above it moves the element
        // less than it grew (the title's 8px bottom margin swallowed 8px of the price's)
        for (let pass = 0; pass < 3; pass++) {
          const push = lowest - el.getBoundingClientRect().top;
          if (push < 0.5) break;
          el.style.marginTop = `${parseFloat(getComputedStyle(el).marginTop) + push}px`;
          el.dataset.coursesOffset = '';
        }
      });
    });
    root.classList.remove('is-measuring');
  }

  function initCourses(root) {
    if (root.dataset.coursesInit) return; // guard against double-binding
    root.dataset.coursesInit = '1';

    let width = 0;
    new ResizeObserver(([entry]) => {
      // Aligning changes the height, never the width, so this does not loop
      if (entry.contentRect.width === width) return;
      width = entry.contentRect.width;
      align(root);
    }).observe(root);

    document.fonts.ready.then(() => align(root));
  }

  const initAll = (scope) =>
    (scope || document).querySelectorAll('[data-courses-root]').forEach(initCourses);

  initAll(); // `defer` guarantees the DOM is parsed
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
